import { Directive } from '@angular/core';

@Directive({
  selector: '[appCheckboxLabelTemplate]'
})
export class CheckboxLabelTemplateDirective { }
